import type { RouteRecordRaw } from 'vue-router';

export const cTEMA_FINANCEIRO_ROUTES = {
  //Raiz do módulo
  name: 'TemaFinanceiro',
  path: 'financeiro',
  component: () => import('@/modules/temas/tema-financeiro/LayoutTemaFinanceiro.vue'),

  ResumoPagar: {
    name: 'ResumoPagarTemaFinanceiro',
    path: 'pagar',
    component: () => import('@/modules/temas/tema-financeiro/page/pagar-resumo/PagarResumoFinanceiro.vue'),
  },

  ResumoReceber: {
    name: 'ResumoReceberTemaFinanceiro',
    path: 'receber',
    component: () => import('@/modules/temas/tema-financeiro/page/receber-resumo/ReceberResumoFinanceiro.vue'),
  },

  PagarReceber: {
    name: 'PagarReceberTemaFinanceiro',
    path: 'resumo',
    component: () => import('@/modules/temas/tema-financeiro/page/pagar-receber/PagarReceberFinanceiro.vue'),
  },

  Inadimplencia: {
    name: 'InadimplenciaTemaFinanceiro',
    path: 'inadimplencia',
    component: () => import('@/modules/temas/tema-financeiro/page/inadimplencia/Inadimplencia.vue'),
  },

  Personalizado: {
    path: 'personalizado',
    name: 'PersonalizadoTemaFinanceiro',

    Gerenciador: {
      path: 'gerenciador',
      name: 'GerenciadorPersonalizadoTemaFinanceiro',
      component: () =>
        import('@/modules/temas/tema-financeiro/page/personalizado/GerenciadorPersonalizadoTemaFinanceiro.vue'),
    },

    Dashboard: {
      props: true,
      path: 'dashboard/:idMenu',
      name: 'DashboardPersonalizadoTemaFinanceiro',
      component: () =>
        import('@/modules/temas/tema-financeiro/page/personalizado/LayoutDashboardPersonalizadoTemaFinanceiro.vue'),
    },
  },
};

export const rotasTemaFinanceiro: Array<RouteRecordRaw> = [
  {
    path: cTEMA_FINANCEIRO_ROUTES.path,
    name: cTEMA_FINANCEIRO_ROUTES.name,
    component: cTEMA_FINANCEIRO_ROUTES.component,
    children: [
      {
        name: cTEMA_FINANCEIRO_ROUTES.ResumoPagar.name,
        path: cTEMA_FINANCEIRO_ROUTES.ResumoPagar.path,
        component: cTEMA_FINANCEIRO_ROUTES.ResumoPagar.component,
      },

      {
        name: cTEMA_FINANCEIRO_ROUTES.ResumoReceber.name,
        path: cTEMA_FINANCEIRO_ROUTES.ResumoReceber.path,
        component: cTEMA_FINANCEIRO_ROUTES.ResumoReceber.component,
      },

      {
        name: cTEMA_FINANCEIRO_ROUTES.PagarReceber.name,
        path: cTEMA_FINANCEIRO_ROUTES.PagarReceber.path,
        component: cTEMA_FINANCEIRO_ROUTES.PagarReceber.component,
      },

      {
        name: cTEMA_FINANCEIRO_ROUTES.Inadimplencia.name,
        path: cTEMA_FINANCEIRO_ROUTES.Inadimplencia.path,
        component: cTEMA_FINANCEIRO_ROUTES.Inadimplencia.component,
      },

      {
        name: cTEMA_FINANCEIRO_ROUTES.Personalizado.name,
        path: cTEMA_FINANCEIRO_ROUTES.Personalizado.path,
        children: [
          {
            name: cTEMA_FINANCEIRO_ROUTES.Personalizado.Gerenciador.name,
            path: cTEMA_FINANCEIRO_ROUTES.Personalizado.Gerenciador.path,
            component: cTEMA_FINANCEIRO_ROUTES.Personalizado.Gerenciador.component,
          },

          {
            name: cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.name,
            path: cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.path,
            props: cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.props,
            component: cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.component,
          },
        ],
      },
    ],
  },
];
